export const SEO_TYPES = {
  PRODUCT: 'Product',
  CATEG: 'Categ',
  REDIRECT: 'Redirect',
  REDIRECT_302: 'Redirect_302',
  REDIRECT_PERMANENT: 'Redirect_Permanent',
  ESPOT: 'espot',
  HTMLCONTENT: 'htmlContent',
  ITEM: 'Item',
  CATEGLISTING: 'CategListing',
  CATEG_WB: 'CATEG_WB',
  CATEG_WB_PREFIX_ID: 'caisse-panachee',
  CATEG_CU: 'CATEG_CU',
  CATEG_CU_PREFIX_ID: 'a-lunite',
  CATEG_SPIRIT: 'CATEG_SPIRIT',
  CATEG_SPIRIT_CU: 'CATEG_SPIRIT_CU',
  PRODUCT_SPIRIT: 'PRODUCT_SPIRIT',
  ITEM_SPIRIT: 'ITEM_SPIRIT',
  CUSTOMER_LOYALTY: 'CUSTOMER_LOYALTY'
};
